//公共js,以及基本方法封装 nvue里使用
import {
	isWeChat,
	get_is_share_mandatory_login,
	navBack
} from '@/utils/util.js';
import {
	user
} from './api.js';
import Vue from 'vue'
import store from '@/store/index'
const fetch = {
	toast: function (tips, callBack) {
		uni.showToast({
			title: tips || "出错啦~",
			icon: 'none',
			duration: 2000,
			success: (res) => {
				callBack && callBack(res)
			}
		})
	},
	setToken: function (token) {
		uni.setStorageSync("token", token)
	},
	getToken() {
		return uni.getStorageSync("token")
	},
	isLogin: function () {
		let flag = ''
		if (!uni.getStorageSync("token")) { // 为登录
			if (uni.getStorageSync('openid')) {
				flag = 'no-mobile'
			} else {
				flag = 'no-login'
			}
		} else {
			flag = 'login'
		}
		return flag
		// return uni.getStorageSync("token") ? true : false
	},
	logout: function () {
		uni.removeStorageSync("token");
		uni.removeStorageSync("openid");
		uni.removeStorageSync('userInfo');
		uni.removeStorageSync('pid');
		fetch.toast('登出成功')
		uni.reLaunch({
			url: '/pages/index/index'
		})
	},
	// 获取当前环境
	getPlatform() {
		let platform = 'h5';

		platform = isWeChat() ? 'wechat' : 'h5';
















		return platform;
	},
	getUrlParam: function (name, pageObj) {
		var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
		// let url = window.location.href.split('#')[0]
		let url = window.location.href;
		let search = url.split('?')[1]
		if (search) {
			var r = search.substr(0).match(reg)
			if (r !== null) {
				return unescape(r[2])
			}
			return null
		} else {
			return null
		}
	},
	loginModel: function (data, callback) { 
		if (data && data.type == 'login') {
			data = {
				type: 'login',
				title: '登录',
				content: data.content || '您还没有登录噢~',
				confirmText: '去登录',
				cancelText: '再看看'
			}
		}
		uni.showModal({
			title: data && data.title || '提示',
			content: data && data.content || '',
			confirmText: data && data.confirmText || '确定',
			cancelText: data && data.cancelText || '取消',
			success: (res) => {
				if (!callback && res.confirm && data && data.type == 'login') {
					store.commit('signOut')
					uni.navigateTo({
						url: '/pages/public/login'
					})
				}
				if (callback) {
					callback(res)
				}
			},
			fail: (err) => {
				callback(err)
			}
		});
	},
	request: function (requestData) {
		let currPage;
		let pages = getCurrentPages();






		let prevPage = pages[pages.length - 1]; // 上一级路由
		currPage = pages[pages.length - 1]; // 当前页路由


		let platform = fetch.getPlatform();
		let url = requestData.url,
			postData = requestData.data,
			method = requestData.method,
			showLoading = requestData.showLoading,
			header = requestData.header || {};
		
		//接口请求
		method = (method === 'post' || method === 'POST') ? 'POST' : 'GET';
		if (showLoading) {
			uni.showLoading({
				mask: true,
				title: '请稍候...'
			})
		}

		const access_token = fetch.getToken() || "";
		let request_header = {			
			'content-type': header.contentType ?  header.contentType : 'application/json',
			'x-mall-sign': uni.getStorageSync("sign") || '3ca759dd492c596201959aac1ef16772',
			'x-access-token': access_token,
			'x-parent-id': uni.getStorageSync('pid') || -1,
			'x-source': uni.getStorageSync('source') || 0,
			'x-app-platform': platform,
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Headers':'DNT,X-Mx-ReqToken,Keep-Alive,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type, Accept-Language, Origin, Accept-Encoding',
		}
		if(uni.getStorageSync('openid')) request_header.openid = uni.getStorageSync('openid');
		return new Promise((resolve, reject) => {
			uni.request({
				url: url,
				data: postData,
				header: request_header,
				method: method,
				dataType: 'json',
				success: (res) => {
					if (res.statusCode === 500) {
						fetch.toast("服务错误~")
						reject(res)
					}
					showLoading && uni.hideLoading()
					if (res.data.code == -1000 || res.data.code == -1002 || res.data.code == -1003) {

						
						let preUrl = prevPage.$route.fullPath;
						console.log("H5",preUrl)
						let pages_index = getCurrentPages();
						console.log(pages_index[pages_index.length-1])
						uni.setStorageSync("_login_pre_url", preUrl);


















						store.commit('signOut')
						let data = {
							type: 'login',
							content: res.data.message
						}
						//uni.setStorageSync('isToLogin',false)
						let isToLogin = uni.getStorageSync('isToLogin');
						//fetch.toast("错误~"+isToLogin)
						if(isToLogin && isToLogin!=""){
							return 
						}else{
							//uni.setStorageSync('isToLogin',true)
							setTimeout(function() {
								uni.setStorageSync('isToLogin',false)
								uni.removeStorageSync('isToLogin');
							}, 3000)
							fetch.loginModel(data, res => {
								let _currRoute = ''

								_currRoute = currPage.route;




								if (res.confirm) {
									uni.navigateTo({
										url: '/pages/public/login'
									})
								}
							})
						}
						// return;
					} else if (res.data.code == -1001) {
						const event = Vue.prototype.$eventHub
						event && event.$emit("bindPhone")
					} else {
						if(res.data.message) fetch.toast(res.data.message+'***'+url);
						resolve(res.data)
					}
					
				},
				fail: (res) => {

					fetch.toast("网络不给力，请稍后再试~")


					reject(res)
				}
			})
		})
	},
	// 上传头像
	/**
	 * formData 图片: images; 文件: files; 视频: videos; 音频: voices
	 * */
	uploadFile: function (requestData) {
		let { url, filePath, name, formData } = requestData;
		let platform = fetch.getPlatform();
		const access_token = fetch.getToken() || "";

		return new Promise((resolve, reject) => {
			uni.uploadFile({
				url: url,
				name: name || 'file',
				header: {
					'x-mall-sign': (uni.getStorageSync("sign") + '') || '5',
					'x-access-token': access_token,
					'x-parent-id': (uni.getStorageSync('pid') + '') || '-1',
					'x-app-platform': platform
				},
				formData: formData,
				filePath: filePath,
				success: function (res) {
					if (res.statusCode === 500) {
						fetch.toast("服务错误~")
						reject(res)
					}
					resolve(JSON.parse(res.data))
				},
				fail: function (err) {
					fetch.toast("网络不给力，请稍后再试~")
					reject(err)
				}
			})

		})

	},
	setUserInfo: function (callBack, data = null) {
		fetch.request({
			url: user.userInfo,
			method: 'get',
			data
		}).then(res => {
			if (res.code == 0) {
				store.commit("setUserInfo", res.data)
				callBack(res.data)
			} else {
				fetch.toast(res.message)
			}
		});
	}
}
module.exports = {
	request: fetch.request,
	uploadFile: fetch.uploadFile,
	toast: fetch.toast,
	isLogin: fetch.isLogin,
	setToken: fetch.setToken,
	getUrlParam: fetch.getUrlParam,
	logout: fetch.logout,
	setUserInfo: fetch.setUserInfo,
	getPlatform: fetch.getPlatform,
	loginModel: fetch.loginModel,
	getToken: fetch.getToken
}